<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
          
       
       <div class="row mb-md-4 align-items-center form-header">
            <div class="col mt-4">
              <h4 class="ms-lg-4 ms-md-2">Add School Details</h4>
            </div>
           
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                Back to Education Fee
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
        <div class="col-lg-8 col-md-12 col-sm-12  m-lg-4 m-md-2">
              <div class="card p-4">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="schoolName" :aria-label="Firstname"
                      >School Name:</llp-label
                    >
                    <llp-input
                      id="schoolNameId"
                      class="w-100"
                      autocomplete="off"
                      v-model="schoolName"
                      :errors="validator.schoolName.$errors"
                    ></llp-input>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="branchName" :aria-label="branchName"
                      >Branch Name:</llp-label
                    >
                    <llp-input
                      id="branchNameId"
                      class="w-100"
                      autocomplete="off"
                      v-model="branchName"
                      :errors="validator.branchName.$errors"
                    ></llp-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <llp-label id="state" :aria-label="State">
                      State:
                    </llp-label>
                    <select
                      id="state"
                      class="form-control select-dropdown"
                      v-model="state"
                    >
                      <option value="" disabled selected>
                        Select your state
                      </option>
                      <option
                        v-for="states in stateList"
                        :key="states.id"
                        :value="states.id"
                      >
                        {{ states.name }}
                      </option>
                    </select>
                    <div v-if="validator.state.$error" class="text-danger">
                      <p>{{ validator.state.$errors[0].$message }}</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="branchName" :aria-label="Firstname"
                      >City:</llp-label
                    >
                    <select
                      id="city"
                      class="form-control select-dropdown"
                      v-model="city"
                    >
                      <option value="" disabled selected>
                        Select your city
                      </option>
                      <option
                        v-for="city in cityList"
                        :key="city.id"
                        :value="city.id"
                      >
                        {{ city.name }}
                      </option>
                    </select>
                    <div v-if="validator.city.$error" class="text-danger">
                      <p>{{ validator.city.$errors[0].$message }}</p>
                    </div>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="pincodeLabel" :aria-label="Firstname"
                      >Pincode:</llp-label
                    >
                    <llp-input
                      id="pincodeId"
                      class="w-100"
                      autocomplete="off"
                      v-model="pinCode"
                      :errors="validator.pinCode.$errors"
                    ></llp-input>
                  </div>
                </div>
               <h5 class="mt-2 fw-bold bank-details">Bank Details</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="pincodeLabel" :aria-label="number"
                        >Account Number:</llp-label
                      >
                      <llp-input
                        id="acountNumberId"
                        class="w-100"
                        autocomplete="off"
                        v-model="accountNumber"
                        :errors="validator.accountNumber.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="pincodeLabel" :aria-label="name"
                        >Account Holder Name:</llp-label
                      >
                      <llp-input
                        id="accountName"
                        class="w-100"
                        autocomplete="off"
                        v-model="accountHolderName"
                        :errors="validator.accountHolderName.$errors"
                      ></llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="BankName" :aria-label="Firstname"
                        >Bank Name:</llp-label
                      >
                      <Dropdown
                        id="BankNameId"
                        v-model="bankName"
                        :options="bankData"
                        optionLabel="bank_name"
                        placeholder="Select your bank name"
                        class="form-control select-dropdown bbps-service-dropdown mobile-optimized-dropdown"
                        @change="onBankSelect"
                        filter
                        filterBy="bank_name"
                      >
                        <template #value="slotProps">
                          <div
                            v-if="slotProps.value"
                            class="flex align-items-center"
                          >
                            <div class="text-truncate bank-options">
                              {{ slotProps.value.bank_name }}
                            </div>
                          </div>
                          <span v-else>Select your bank name</span>
                        </template>

                        <template #option="slotProps">
                          <div class="flex align-items-center">
                            <div class="dropdown-option-text">
                              {{ slotProps.option.bank_name }}
                            </div>
                          </div>
                        </template>
                      </Dropdown>

                      <div v-if="validator.bankName.$error" class="text-danger">
                        <p>{{ validator.bankName.$errors[0].$message }}</p>
                      </div>
                    </div>
                    <!-- Show the Bank Branch dropdown only if a bank is selected -->
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="IFSCCodeLabel" :aria-label="ifscCode"
                        >IFSC Code:</llp-label
                      >
                      <llp-input
                        id="ifscCodeInput"
                        v-model="ifscCode"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.ifscCode.$errors"
                        placeholder="Enter IFSC code"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="branch" :aria-label="Branch"
                        >Branch:</llp-label
                      >
                      <llp-input
                        id="MonthlyRentInput"
                        v-model="branch"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.branch.$errors"
                      ></llp-input>
                    </div>
                  </div>
                      </div>
                    </div>
                  
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <llp-button
                      classNames="btn-secondary text-white new-btn"
                      type="submit"
                      :loadSpinner="showLoginSpinner"
                       @click="addSchool()"
                      >Add School</llp-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import ErrorService from "../../../services/error.service";
import { helpers, required,numeric,maxLength } from "@vuelidate/validators";
import NetworkService from "@/services/network.service";
import Dropdown from "primevue/dropdown";

export default {
  setup: () => ({ validator: useVuelidate() }),
  components: {
    Dropdown,
  },
  data() {
    return {
      schoolName: "",
      branchName: "",
      state: "",
      city: "",
      pinCode: "",
      bankName: "",
      branch: "",
      ifscCode: "",
      accountNumber: "",
      accountHolderName: "",
      availableBranches: [],
      availableIfscCodes: {},
      stateList: [],
      cityList: [],
      userId: localStorage.getItem("User_id"),
      serviceId: this.$route.params.serviceId,
      showLoginSpinner: false,
      bankData: [],

    };
  },

  validations() {
    return {
      schoolName: {
        required: helpers.withMessage("School name is required.", required),
      },
      branch: {
        required: helpers.withMessage("Branch is required.", required),
         alphaOnly: helpers.withMessage(
          "Branch should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      state: {
        required: helpers.withMessage("State is required.", required),
        
      },
      city: {
        required: helpers.withMessage("City is required.", required),
       
      },
      branchName: {
        required: helpers.withMessage("Branch name is required.", required),
         alphaOnly: helpers.withMessage(
          "Branch name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      pinCode: {
          required: helpers.withMessage("Pin code is required.", required),
           numeric: helpers.withMessage("Pin code must contain only numbers.", numeric),
          maxLength: helpers.withMessage("Pin code must be 6 digits.", maxLength(6)),
        },
      accountNumber: {
        required: helpers.withMessage("Account number is required.", required),
         numericOnly: helpers.withMessage(
          "Account number should contain only numbers.",
          (value) => /^\d+$/.test(value)
        ),
      },
      accountHolderName: {
        required: helpers.withMessage(
          "Account holder name is required.",
          required
        ),
         alphaOnly: helpers.withMessage(
          "Account holder name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      bankName: {
        required: helpers.withMessage("Bank name  is required.", required),
      },
      ifscCode: {
        required: helpers.withMessage("IFSC code is required.", required),
         alphanumeric: helpers.withMessage(
          "IFSC code should contain only characters and numbers.",
          (value) => /^[A-Za-z0-9]+$/.test(value)
        ),
      },
    };
  },
  watch: {
    state(newVal) {
      if (newVal) {
        this.fetchingCities(newVal);
      } else {
        this.cityList = [];
      }
    },
  },

  mounted() {
    this.fetchingStates();
    this.fetchBankDetail();
  },
  methods: {
    BackToServices() {
      this.$router.back();
    },

    async fetchBankDetail() {
      try {
        const responseData = await NetworkService.get("bank-list");
        this.bankData = responseData;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching bank details", "error");
      }
    },
    onBankSelect() {
      if (this.bankName && this.bankName.ifsc_code) {
        this.ifscCode = this.bankName.ifsc_code;
      } else {
        this.ifscCode = "";
        this.branch = "";
      }
    },
    async fetchingStates() {
      try {
        const stateResponse = await NetworkService.get("/states-list");
        this.stateList = stateResponse.states;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the states", "error");
      }
    },
    async fetchingCities(id) {
      try {
        const cityResponse = await NetworkService.get(`/cities-list/${id}`);
        this.cityList = cityResponse.cities;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the cities", "error");
      }
    },
    async addSchool() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return Promise.reject();
          this.showLoginSpinner = true;
          const schoolData = {
            user_id: this.userId,
            service_id: this.serviceId,
            school_name: this.schoolName,
            branch_name: this.branchName,
            state: String(this.state),
            city: String(this.city),
            pincode: this.pinCode,
            account_number: this.accountNumber,
            account_holder_name: this.accountHolderName,
            bank_name: this.bankName?.bank_name,
            bank_branch: this.branch,
            ifsc_code: this.ifscCode,
          };

          try {
            const addingSchoolResponse = await NetworkService.post(
              "store-service-list",
              schoolData
            );
            this.$refs.toast.show(addingSchoolResponse.data.message,"success");
            this.showLoginSpinner = false;
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } catch (error) {
            this.showLoginSpinner = false;
              const errorMessage =
              error?.message || "Unable to adding the school details.";
            this.$refs.toast.show(errorMessage, "error");
            // this.$refs.toast.show(
            //   "Unable to adding the school details.",
            //   "error"
            // );
          }
        })
        .catch((error) => {
          this.showLoginSpinner = false;

          if (error) {
            this.$refs.toast.show(
              "Unable to adding the school details.",
              "error"
            );
          } else {
            this.$refs.toast.show(
              ErrorService.getErrorMessages(error),
              "error"
            );
          }
        });
    },
  },
};
</script>
